import api from '@/api'
import store from '@/store'
import utils from '@/utils'
import moment from 'moment';
const FileSaver = require('file-saver')

export default {
  async extractReportPost(url, platform, operation = 'insights') {
    const response = await api.request('post', `/api/v1/social-data/reports/posts/${operation}`, true, { url, platform });
    if (!response.data || response.data.success !== true) throw new Error('Post extraction returned no usable data.');
    return response.data;
  },
  paginate(options) {
    const searchParams = new URLSearchParams()
    Object.entries(options).forEach(([key, value]) => {
      // Optional filters must be omitted instead of serialized as `key=`.
      // In particular, an empty status must mean "all statuses", not a filter.
      if (value === '' || value === null || value === undefined) return
      searchParams.set(key, String(value))
    })
    const params = searchParams.toString()
    return new Promise(function (resolve, reject) {
      const url = params ? `/api/v1/campaigns?${params}` : '/api/v1/campaigns'
      api
        .request('get', url, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  paginateRateCard(options) {
    const params = Object.keys(options)
      .map(key => `${key}=${options[key]}`)
      .join('&')
    return new Promise(function (resolve, reject) {
      const url = `/api/v1/pairings?${params}`
      api
        .request('get', url, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  updateRateCard(pairingIDs, initialRateCards, campaignID) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/pairings/updateratecard', true, { pairingIDs, initialRateCards, campaignID })
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  approveRateCard(rowID, editRateCard) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/pairings/approveratecard', true, { rowID, editRateCard })
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  rejectRateCard(rowID) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/pairings/rejectratecard', true, { rowID })
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getAllReportRecognized() {
    return new Promise(function (resolve, reject) {
      api
        .request('get', `/api/v1/campaigns/reports/recognized?limit=999`, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getMonthlyCampaignsReport({ from, to }) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', '/api/v1/campaigns/reports/monthly?from=' + from + '&to=' + to, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getAllCampaigns(campaignStatus, force) {
    return new Promise(function (resolve, reject) {
      const cacheCampaignList = store.state.cache.campaignList

      if (cacheCampaignList[campaignStatus] && cacheCampaignList[campaignStatus]['data'] && force === false) {
        resolve(cacheCampaignList[campaignStatus])
      } else {
        api
          .request('get', '/api/v1/campaigns?limit=999&status=' + campaignStatus, true)
          .then(response => {
            if (response.status !== 200) {
              reject(response)
              return
            }

            // Save to Vuex store
            store.commit('SET_CAMPAIGNS', {
              campaignStatus,
              data: response.data
            })

            resolve(store.state.cache.campaignList[campaignStatus])
          })
          .catch(error => {
            // Request failed.
            reject(error)
          })
      }
    })
  },
  async getPayoutCampaignPicker(force = false) {
    const campaignStatus = 'payout-picker'
    const cacheCampaignList = store.state.cache.campaignList

    if (cacheCampaignList[campaignStatus] && cacheCampaignList[campaignStatus].data && !force) {
      return cacheCampaignList[campaignStatus].data
    }

    const response = await api.request('get', '/api/v1/campaigns/payout-picker', true)
    if (response.status !== 200) throw new Error('Error')

    store.commit('SET_CAMPAIGNS', {
      campaignStatus,
      data: response.data
    })
    return response.data
  },
  downloadCampaignDetailsReport(campaignIDs, exportType) {
    return new Promise(function (resolve, reject) {
      api
        .download('/api/v1/campaigns/detail/download-report', 'POST', {campaignIDs, exportType})
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          if (exportType === 'csv') {
            const blob = new Blob([response.data], {
              type: 'utf-8'
            })
            FileSaver.saveAs(blob, response.headers.filename)
          } else if (exportType === 'excel') {
            const blob = new Blob([response.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            })
            FileSaver.saveAs(blob, response.headers.filename)
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  downloadAllCampaignsReport(campaigns, exportType) {
    return new Promise(function (resolve, reject) {
      api
        .download('/api/v1/campaigns/all/download-report', 'POST', {campaigns, exportType})
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          if (exportType === 'csv') {
            const blob = new Blob([response.data], {
              type: 'utf-8'
            })
            FileSaver.saveAs(blob, response.headers.filename)
          } else if (exportType === 'excel') {
            const blob = new Blob([response.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            })
            FileSaver.saveAs(blob, response.headers.filename)
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  downloadSystemPerformanceReport(exportType) {
    return new Promise(function (resolve, reject) {
      api
        .download('/api/v1/campaigns/performance/download-report', 'POST', {exportType})
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          if (exportType === 'csv') {
            const blob = new Blob([response.data], {
              type: 'utf-8'
            })
            FileSaver.saveAs(blob, response.headers.filename)
          } else if (exportType === 'excel') {
            const blob = new Blob([response.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            })
            FileSaver.saveAs(blob, response.headers.filename)
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  downloadMasterListsReport(data) {
    return new Promise(function (resolve, reject) {
      api
        .download('/api/v1/campaigns/master-lists/all/download-report', 'POST', data)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          FileSaver.saveAs(blob, `Masterlists Report (${utils.func.formatCustomDate(moment(), 'DD MMM YYYY')}).xlsx`)
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  downloadClientFeedback(forms) {
    return new Promise(function (resolve, reject) {
      api
        .download('/api/v1/campaigns/client-feedback/download', 'POST', forms)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          FileSaver.saveAs(blob, `Client_Feedback_Forms_${moment().format('X')}.xlsx`)
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getUnfinishedCampaigns() {
    return new Promise(function (resolve, reject) {
      api
        .request('get', '/api/v1/campaigns/all/unfinished?limit=999', true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getAllCampaignsNoStatus(filters = {}) {
    // filters.limit = 999
    return new Promise(function (resolve, reject) {
      const params = Object.keys(filters)
      .map(key => `${key}=${filters[key]}`)
      .join('&')
      api
        .request('get', `/api/v1/campaigns/all?${params}`, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getCampaign(campaignID) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', '/api/v1/campaigns/' + campaignID, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  /**
   * Nyein
   * Get report groups
   * @param {Report ID} reportID
   */
  getReportGroups(campaignID) {
    return new Promise((resolve, reject) => {
      // Construct the query parameters
      const queryParams = campaignID ? `?campaignID=${campaignID}` : '';

      api
        .request('get', `/api/v1/campaigns/reports/groups${queryParams}`, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response);
            return;
          }
          resolve(response.data);
        })
        .catch(error => {
          // Request failed.
          reject(error);
        });
    });
  },
  /**
   * Nyein
   * Get report group
   * @param {Report ID} reportID
  */
  addReportGroup(reportGroup) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/campaigns/reports/groups/add', true, reportGroup)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  /**
   * Nyein
   * Delete Report Group
   * @param {Integer} groupID
   * @returns
   */
  deleteReportGroup(groupID) {
    return new Promise(function (resolve, reject) {
      api
        .request('delete', '/api/v1/campaigns/reports/groups/' + groupID, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  /**
   * Aung
   * Added for the vender email
   * @param {Client Id} clientID
   */
  getCampaignsByClientID(clientID) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', '/api/v1/campaigns/by/client/' + clientID, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  addPostToCampaign(body) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/campaigns/reports/', true, body)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  updateCampaignActivationStatus(campaignID, status) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/campaigns/' + campaignID + '/activate', true, { status })
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  updateCampaignDirectRelease(campaignID) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/campaigns/' + campaignID + '/direct-release', true, { status })
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  createCampaign(campaign) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/campaigns', true, campaign)
        .then(response => {
          if (response.status !== 201) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  editCampaign(campaignID, formData) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/campaigns/' + campaignID, true, formData)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  createCampaignByAllocate(campaign) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/campaigns/create/by/allocate', true, campaign)
        .then(response => {
          if (response.status !== 201) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  updateCampaignSummary(campaignID, formData) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/campaigns/' + campaignID + '/summary/update', true, formData)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  updateSegment(campaignID, formData) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/campaigns/' + campaignID + '/segment/update', true, formData)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  createLineUp(campaignID, formData) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/campaigns/' + campaignID + '/create/lineup', true, formData)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  updateLineUp(campaignID, formData) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/campaigns/' + campaignID + '/update/lineup', true, formData)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  updatePostAnalysisStatus(campaignID, formData) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/campaigns/' + campaignID + '/postAnalysisStatus/update', true, formData)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  updateStoryAnalysisStatus(campaignID, formData) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/campaigns/' + campaignID + '/storyAnalysisStatus/update', true, formData)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  updateTikTokAnalysisStatus(campaignID, formData) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/campaigns/' + campaignID + '/tikTokAnalysisStatus/update', true, formData)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  updateYoutubeAnalysisStatus(campaignID, formData) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/campaigns/' + campaignID + '/youtubeAnalysisStatus/update', true, formData)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  updatePairingDisplayStatus(campaignID, formData) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/campaigns/' + campaignID + '/pairingDisplayStatus/update', true, formData)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  deleteCampaign(campaignID) {
    return new Promise(function (resolve, reject) {
      api
        .request('delete', '/api/v1/campaigns/' + campaignID, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  deleteBulkCampaigns(campaignIds) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/campaigns/bulk-delete/campaigns', true, {
          ids: campaignIds
        })
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  approveCampaign(campaignID, currentStatus) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/campaigns/' + campaignID + '/status/' + currentStatus, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  changeStatus(campaignID, updateStatus) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/campaigns/' + campaignID + '/changeStatus/' + updateStatus, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  changeBulkStatus(campaignIds, updateStatus) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/campaigns/changeBulkStatus/' + updateStatus, true, {
          ids: campaignIds
        })
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getInfluencerID(userID) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', '/api/v1/campaigns/influencerid/' + userID, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getPairings(campaignID) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', '/api/v1/campaigns/' + campaignID + '/pairings', true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  invitePairings(pairingIDs) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/pairings/status', true, { pairingIDs })
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getPendingRateCard(campaignID) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', '/api/v1/pairings/pendingratecard', true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  requestRateCardApproval(pairingIDs, editRateCards, initialRateCards, campaignID) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/pairings/ratecard', true, { pairingIDs, editRateCards, initialRateCards, campaignID })
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getRateCard(campaignID, influencerID) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', `/api/v1/pairings/ratecard/campaignID/${campaignID}/influencerID/${influencerID}`, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  acceptInvite(pairingID) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/pairings/status', true, { pairingID })
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  rejectInvite(pairingID) {
    return new Promise(function (resolve, reject) {
      api
        .request('delete', '/api/v1/pairings/status', true, { pairingID })
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getPosts(campaignID) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', '/api/v1/campaigns/' + campaignID + '/posts', true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getPostsForClient(clientID) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', `/api/v1/campaigns/posts-client?clientID=${clientID}`, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  createPost(campaignID, form) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/campaigns/' + campaignID + '/posts', true, form)
        .then(response => {
          if (response.status !== 201) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  editPost(campaignID, postID, form) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', `/api/v1/campaigns/${campaignID}/posts/${postID}`, true, form)
        .then(response => {
          if (response.status !== 201) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  updatePost(campaignID, postID, instagramURL) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', `/api/v1/campaigns/${campaignID}/posts/${postID}`, true, { instagramURL: instagramURL })
        .then(response => {
          if (response.status !== 201) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  approvePost(postID, currentStatus) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/posts/' + postID + '/status/' + currentStatus, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  rejectPost(postID, currentStatus) {
    return new Promise(function (resolve, reject) {
      api
        .request('delete', '/api/v1/posts/' + postID + '/status/' + currentStatus, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  createComment(campaignID, newComment) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/campaigns/' + campaignID + '/comments', true, newComment)
        .then(response => {
          if (response.status !== 201) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getComments(campaignID, conditions) {
    var urlCondition = '?'
    for (var key in conditions) {
      urlCondition += key + '=' + conditions[key] + '&'
    }
    urlCondition = urlCondition.slice(0, -1)

    return new Promise(function (resolve, reject) {
      api
        .request('get', '/api/v1/campaigns/' + campaignID + '/comments' + urlCondition, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },

  async getUnreadComments(campaignID) {
    try {
      let response = await api.request('get', `/api/v1/campaigns/${campaignID}/comments/unread`, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },

  async markCommentAsRead(commentsId) {
    try {
      commentsId = commentsId.join(',')
      let response = await api.request('patch', `/api/v1/campaigns/comments/mark-as-read?commentIds=${commentsId}`, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },

  async assignCsToCampaign(campaignID, cs) {
    try {
      let response = await api.request('patch', `/api/v1/campaigns/${campaignID}/assign/cs`, true, cs)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },

  async resetPasscode(campaignID, passcode) {
    try {
      let response = await api.request('patch', `/api/v1/campaigns/${campaignID}/reset/passcode`, true, {passcode})
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },

  // login Campaign Report with Passcode
  async loginCampaignReport(campaignID, passcode) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', `/api/v1/campaigns-html-report/${campaignID}/login`, false, {passcode})
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },

  // send Campaign brief in pdf
  sendCampaignPDF(campaignID, pdfDoc) {
    let data = {
      attachment: pdfDoc
    }
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/campaigns/' + campaignID + '/pdf', true, data)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  // Get Posts from Payment Services by Campaign Id
  async getPostsFromPaymentsByCampaignId(campaignID) {
    try {
      let response = await api.request('get', `api/v1/payments/posts/${campaignID}`, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  // Generate Campaign Report and Return the generated report
  async generateCampaignReportPDF(campaignID, name, force) {
    try {
      let response = await api.download(`/api/v1/campaigns/${campaignID}/report?force=${force}&fmt=pdf`, 'GET')
      const blob = new Blob([response.data], {
        type: 'application/pdf'
      })
      FileSaver.saveAs(blob, name + '-report.pdf')
    } catch (error) {
      throw error
    }
  },
  // Generate Campaign Report in excel format
  async generateCampaignReportExcel(campaignID, name, force) {
    try {
      let response = await api.download(`/api/v1/campaigns/${campaignID}/report?force=${force}&fmt=xlsx`, 'GET')
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })
      FileSaver.saveAs(blob, name + '-report.xlsx')
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  // Generate Campaign Report in excel format on posts
  async generateCampaignReportExcelonPosts(campaignID, name, force) {
    try {
      let response = await api.download(`/api/v1/campaigns/${campaignID}/report?force=${force}&fmt=xlsx_posts`, 'GET')
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })
      FileSaver.saveAs(blob, name + '-report.xlsx')
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  // Generate Campaign Report and Return the generated report
  async generateCampaignReport(campaignID, page, force, fmt, reportID) {
    try {
      let response = await api.request('get', `/api/v1/campaigns/${campaignID}/report?page=${page}&force=${force}&fmt=${fmt}&reportID=${reportID}`, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  // get campaign reports by campaign ids
  async getReportsByCampaignIDs(campaignIDs, refresh = false) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/campaigns/reports/by/campaignIDs', true, {campaignIDs, refresh})
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  // get campaign reports by campaign ids
  async getReportsForCalendar(query) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/campaigns/reports/for/calendar', true, query)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  // Get Reports Data
  async getPaymentConsolidateReport(filters = {}) {
    const params = Object.keys(filters)
      .map(key => `${key}=${filters[key]}`)
      .join('&')
    try {
      let response = await api.request('get', `/api/v1/campaigns/payment/consolidate/report?${params}`, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  // Export Payment Consolidate Report
  async exportBankReport(data, type) {
    const payload = {
      data,
      type
    }
    try {
      // use downloadPATCH method to download requested data
      let response = await api.downloadPATCH(`/api/v1/campaigns/payment/consolidate/report/bank-export`, 'PATCH', payload)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  // Export Campaign COGS Report
  async exportCampaignCogs(data) {
    const payload = {
      data
    }
    try {
      // use downloadPATCH method to download requested data
      let response = await api.downloadPATCH(`/api/v1/campaigns/cogs/export`, 'PATCH', payload)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  // Generate Campaign HTML Report with using Passcode and return the generated report
  async generateCampaignHTMLReport(campaignID, passcode, page, force, fmt) {
    try {
      let response = await api.request('get', `/api/v1/campaigns-html-report/${campaignID}/report?page=${page}&force=${force}&passcode=${passcode}&fmt=${fmt}`, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  // Generate Campaign Report and Return the generated report
  async removeUrlFromCampaignReport(campaignID, url) {
    const regex = /^(?:https?:\/\/)?(?:www\.)?(?:instagram\.com\/p\/)([\d\w\-_]+)(?:\/)?(\?.*)?$/gm;
    let m;
    let shortcode = '';
    while ((m = regex.exec(url)) !== null) {
      // This is necessary to avoid infinite loops with zero-width matches
      if (m.index === regex.lastIndex) {
        regex.lastIndex++;
      }
      shortcode = m[1];
    }
    try {
      let response = await api.request('delete', `/api/v1/campaigns/${campaignID}/report/${shortcode}`, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async updateCampaignSetting(campaignID, setting) {
    try {
      let response = await api.request('patch', `/api/v1/campaigns/settings/${campaignID}`, true, setting)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async fetchSuggestedInfluencers(size, page, campaignName, contents) {
    let data = {
      name: campaignName,
      texts: contents
    }
    try {
      let response = await api.request('post', `/analyze?size=${size}&page=${page}`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async getFinanceCampaigns() {
    /*
      Should Get all the campaigns except Draft
      Including the Revenue Recognized and COGS values
      And their Payment Status (Outstanding, Partial, Paid)
    */
    try {
      let response = await api.request('get', `/api/v1/campaigns/finance/revenue`, true)
      if (response.status !== 200) {
        throw new Error('error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async deleteContentFromReport(contentID, options = {}) {
    try {
      const params = Object.keys(options)
      .map(key => `${key}=${options[key]}`)
      .join('&')
      let response = await api.request('patch', `/api/v1/campaigns/reports/${contentID}/delete?${params}`, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async updatePostInsights(reportID, data) {
    try {
      let response = await api.request('patch', `/api/v1/campaigns/reports/${reportID}`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async addStoryInsights(campaignID, postID, pairingID, igHandle, country, platform, storyInsights, url, liveDate, postType, typeName) {
    let data = {
      campaignID: campaignID,
      postID: postID || '',
      pairingID,
      username: igHandle.trim(),
      platform,
      media_url: url,
      live_date: liveDate,
      insights: storyInsights,
      postType,
      typeName,
      country
    }
    try {
      let response = await api.request('post', `/api/v1/campaigns/reports/manually`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async addFbInsights(campaignID, postID, pairingID, igHandle, country, platform, fbInsights, url, liveDate, postType, typeName) {
    let data = {
      campaignID: campaignID,
      postID: postID || '',
      pairingID,
      username: igHandle.trim(),
      platform,
      media_url: url,
      live_date: liveDate,
      insights: fbInsights,
      postType,
      typeName,
      country
    }
    try {
      let response = await api.request('post', `/api/v1/campaigns/reports/manually/fbData`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async addXHSInsights(campaignID, postID, pairingID, igHandle, country, platform, xhsID, xhsLink, xhsFollowers, xhsInsights, medias, liveDate, postType, typeName) {
    let data = {
      campaignID: campaignID,
      postID: postID || '',
      pairingID,
      username: igHandle.trim(),
      platform,
      xhsID,
      xhsLink,
      xhsFollowers,
      live_date: liveDate,
      insights: xhsInsights,
      postType,
      typeName,
      country
    }
    try {
      let formData = new FormData();
      formData.append('report', JSON.stringify(data));
      if (medias) formData.append('medias', medias);
      let response = await api.request('post', `/api/v1/campaigns/reports/manually/xhsData`, true, formData)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async addLemonInsights(campaignID, postID, pairingID, igHandle, country, platform, lemonID, lemonLink, lemonFollowers, lemonInsights, medias, liveDate, postType, typeName) {
    let data = {
      campaignID: campaignID,
      postID: postID || '',
      pairingID,
      username: igHandle.trim(),
      platform,
      lemonID,
      lemonLink,
      lemonFollowers,
      live_date: liveDate,
      insights: lemonInsights,
      postType,
      typeName,
      country
    }
    try {
      let formData = new FormData();
      formData.append('report', JSON.stringify(data));
      formData.append('medias', medias);
      let response = await api.request('post', `/api/v1/campaigns/reports/manually/lemonData`, true, formData)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async addPostInsights(campaignID, postID, pairingID, igHandle, country, platform, postInsights, inputtedInsights, url, imageUrl, liveDate, postType, typeName) {
    let data = {
      campaignID: campaignID,
      postID: postID,
      pairingID,
      username: igHandle.trim(),
      platform,
      postURL: url,
      postImageURL: imageUrl,
      live_date: liveDate,
      insights: postInsights,
      inputtedInsights,
      postType,
      typeName,
      country
    }
    try {
      let response = await api.request('post', `/api/v1/campaigns/reports/manually/postData`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async addTikTokInsights(campaignID, pairingID, tikTokHandle, country, platform, tikTokInsights, inputtedInsights, url, liveDate, postType, postID) {
    let data = {
      campaignID: campaignID,
      pairingID,
      username: tikTokHandle.trim(),
      platform,
      postURL: url,
      insights: tikTokInsights,
      inputtedInsights,
      live_date: liveDate,
      postType,
      postID,
      country
    }
    try {
      let response = await api.request('post', `/api/v1/campaigns/reports/manually/tikTokData`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async addYoutubePostInsights(campaignID, postID, pairingID, youtubeHandle, country, platform, youtubeInsights, inputtedInsights, url, liveDate, postType, typeName) {
    let data = {
      campaignID: campaignID,
      postID: postID,
      pairingID,
      username: youtubeHandle.trim(),
      country,
      platform,
      insights: youtubeInsights,
      inputtedInsights,
      postURL: url,
      live_date: liveDate,
      postType,
      typeName
    }
    try {
      let response = await api.request('post', `/api/v1/campaigns/reports/manually/youtubeData`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async addMultipleContents(campaignID, pairingID, igHandle, country, platform, medias, postType, typeName, liveDate, postID) {
    let data = {
      campaignID: campaignID,
      pairingID,
      username: igHandle.trim(),
      platform,
      postType,
      typeName,
      postID,
      live_date: liveDate,
      country
    }
    let formData = new FormData();
    formData.append('report', JSON.stringify(data));
    formData.append('medias', medias);
    try {
      let response = await api.request('post', `/api/v1/campaigns/reports/manually/multipleContents`, true, formData)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async addOtherInsights(campaignID, pairingID, otherHandle, country, platform, otherInsights, url, medias, liveDate, postType, typeName, postID) {
    let data = {
      campaignID: campaignID,
      pairingID,
      username: otherHandle.trim(),
      postURL: url,
      insights: otherInsights,
      live_date: liveDate,
      postType,
      typeName,
      postID,
      country,
      platform
    }
    try {
      let formData = new FormData();
      formData.append('report', JSON.stringify(data));
      formData.append('medias', medias);
      let response = await api.request('post', `/api/v1/campaigns/reports/manually/otherData`, true, formData)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async updateLineUpIndex(data) {
    let campaignID = data.campaignID || null
    let reportID = data.reportID || null
    let requestObj = {
      lineUpIndex: data.lineUpIndex
    }
    if (data.groupID) {
      requestObj.groupID = data.groupID
      requestObj.posts = JSON.stringify(data.posts)
    }
    try {
      let response = await api.request('patch', `/api/v1/campaigns/${campaignID}/${reportID}/lineup`, true, requestObj)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async updateCampaignBenchmark(campaignID, formData) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/campaigns/' + campaignID + '/benchmark/update', true, formData)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  // Get Campaign Vertical Lists
  getAllCampaignVerticals(force) {
    return new Promise(function(resolve, reject) {
      api
        .request('get', '/api/v1/campaigns/verticals', true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          // Save to Vuex store
          store.commit('SET_CAMPAIGNVERTICALS', response.data.campaignVerticals)
          resolve(store.state.cache.campaignVerticalList)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  // Get Countries
  getAllCountries(force) {
    return new Promise(function(resolve, reject) {
      api
        .request('get', '/api/v1/campaigns/countries', true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data.countries)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  // Get Campaign Brand Fact Sheet Lists
  getAllBrandSheets(force) {
    return new Promise(function(resolve, reject) {
      api
        .request('get', '/api/v1/campaigns/brand-fact-sheets/lists', true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  async getFeedbackAccess(campaignID) {
    const response = await api.request('get', '/api/v1/campaigns/' + encodeURIComponent(campaignID) + '/feedback-access', true)
    return response.data
  },
  async changeFeedbackAccess(campaignID, accepting) {
    const response = await api.request('patch', '/api/v1/campaigns/' + encodeURIComponent(campaignID) + '/feedback-access', true, { accepting })
    return response.data
  },
  getCampaignDetailForFeedback(campaignID) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', '/api/v1/campaigns-open/' + encodeURIComponent(campaignID), true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(reject)
    })
  },
  getCampaignDetailForFeedbackInvitation(campaignID, token) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', '/api/v1/campaigns-open/feedback/' + encodeURIComponent(campaignID), false, null, { 'x-feedback-token': token })
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getCampaignDetailForStats(campaignID) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', '/api/v1/campaigns-open/' + campaignID + '?purpose=stats', true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getCampaignInfoForBrandSheet(campaignID) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', '/api/v1/campaigns-open/' + campaignID + '/brand-sheet', true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getAllCampaignsForFeedback(campaignStatus, force) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', '/api/v1/campaigns?limit=999', true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getCampaignsInfluencerReport(options) {
    const query = utils.func.objectToQueryString(options)
    return new Promise(function (resolve, reject) {
      api
        .request('get', `/api/v1/campaigns/influencer/reports?${query}`, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getClientFeedbacks(options) {
    const params = Object.keys(options)
      .map(key => `${key}=${options[key]}`)
      .join('&')
    return new Promise(function (resolve, reject) {
      const url = `/api/v1/campaigns/client-feedback?${params}`
      api
        .request('get', url, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  createClientFeedback(feedback) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/campaigns-open/client-feedback', true, feedback)
        .then(response => {
          if (response.status !== 201) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  createBrandSheet(brandSheet) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/campaigns-open/brand-fact-sheet', true, brandSheet)
        .then(response => {
          if (response.status !== 201) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  async updateReportsByIds(data) {
    try {
      let response = await api.request('patch', `/api/v1/campaigns/reports/update-by/ids`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async updateCampaignByIds(data) {
    try {
      let response = await api.request('patch', `/api/v1/campaigns/update-by/ids`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async saveEditedReportData(data) {
    try {
      let response = await api.request('patch', `/api/v1/campaigns/reports/edited-data`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async savePaymentConsolidatedData(data) {
    try {
      let response = await api.request('patch', `/api/v1/campaigns/reports/payment/consolidated-data`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async savePaymentConsolidatedPayout(data) {
    try {
      let response = await api.request('patch', `/api/v1/campaigns/reports/payment/consolidate/payout`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async savePaymentConsolidatedInvoice(data) {
    try {
      let response = await api.request('patch', `/api/v1/campaigns/report-invoice/create`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async saveReportPartialAmount(campaignID, data) {
    try {
      let response = await api.request('patch', `/api/v1/campaigns/reports/${campaignID}/partial/amount`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async saveReportActualAmount(reportID, data) {
    try {
      let response = await api.request('patch', `/api/v1/campaigns/reports/${reportID}/actual/amount`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  getDealCampaignCount(dealCode) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', '/api/v1/campaigns/deal-code/count/' + dealCode, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  checkUserInCampaignReport(options) {
    const params = Object.keys(options)
      .map(key => `${key}=${options[key]}`)
      .join('&')
    return new Promise(function (resolve, reject) {
      const url = `/api/v1/campaigns/reports/check/owner?${params}`
      api
        .request('get', url, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  async saveReportNote(data) {
    try {
      let response = await api.request('patch', `/api/v1/campaigns/reports/internal-note`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  async saveReportNoteRead(data) {
    try {
      let response = await api.request('patch', `/api/v1/campaigns/reports/read/internal-note`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  uploadEditorImage(formData) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/campaigns/editor/image/upload', true, formData)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  uploadImage(formData) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/campaigns-open/image/upload', true, formData)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  async sendBFSEmail(formData) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/campaigns-open/brand-fact-sheet/email', true, formData)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  /**
   * Nyein
   * Get report groups
   * @param {Report ID} reportID
   */
  getRptDeliverablesByHandle(options) {
    const params = Object.keys(options)
      .map(key => `${key}=${options[key]}`)
      .join('&')
    return new Promise(function (resolve, reject) {
      api
        .request('get', `/api/v1/campaigns/reports/deliverables/byhandle?${params}`, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },

    /**
   * Nyein
   * delete cloudinary file
   * @param {*} formData
   * @returns
  */
  deleteCldFile(formData) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/campaigns/delete/cloudinary', true, formData)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },

    /**
   * Nyein
   * update AOK Report Data
   * @param {*} formData
   * @returns
  */
  saveAOKReport(formData) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/campaigns/update/aok-report', true, formData)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  // Get Uploaded Invoice Lists
  getUploadedInvoiceLists(force) {
    return new Promise(function(resolve, reject) {
      api
        .request('get', '/api/v1/campaigns/report-invoice/find', true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  /**
   * Nyein
   * update report Invoice
   * @param {*} formData
   * @returns
  */
  updateReportInvoice(formData) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/campaigns/report-invoice/update', true, formData)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  // Get Cld Signature
  async getCldSignature(payload) {
    try {
      let response = await api.request('post', `/api/v1/campaigns/get/cloudinary/signature`, true, {options: payload})
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  bulkDeleteInvoices(payload) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/campaigns/report-invoice/bulk-delete', true, payload)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  /**
   * Nyein
   * Delete S3 Object
   * @param {Integer} objectID
   * @returns
  */
  deleteS3Object(objectID) {
    return new Promise(function (resolve, reject) {
      api
        .request('delete', '/api/v1/campaigns/delete/s3/object/' + objectID, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getStatsData(handle) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', '/api/v1/campaigns/stats/data?handle=' + handle, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  storeStatsData(data) {
    return new Promise(function (resolve, reject) {
      api
        .request('POST', '/api/v1/campaigns/store/stats/data', data)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  uploadAIStatsData(data) {
    return new Promise(function (resolve, reject) {
      api
        .request('POST', '/api/v1/campaigns/upload/ai-stats/data', true, data)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getCampaignAISummary(data) {
    return new Promise(function (resolve, reject) {
      api
        .request('POST', '/api/v1/campaigns/context/ai-summary', true, data)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  // Passcode-gated AI summary for the client-facing Kobe HTML report
  getHTMLReportAISummary(campaignID, passcode, data) {
    return new Promise(function (resolve, reject) {
      api
        .request('POST', `/api/v1/campaigns-html-report/${campaignID}/ai-summary?passcode=${encodeURIComponent(passcode)}`, false, data)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getCampaignNotableComments(data) {
    return new Promise(function (resolve, reject) {
      api
        .request('POST', '/api/v1/campaigns/context/ai-notable-comments', true, data)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/views/Campaign/campaignAPIs.js